
export const MENU_ITEMS = {
    USER_DASHBOARD: { name: "User Dashboard", value: "user_dashboard" },
    LANDING_PAGE: { name: "Landing Page", value: "landing_page" },
    BUSINESS_ANALYST: { name: "Business Analyst", value: "business_analyst" },
    PRODUCT_OWNER: { name: "Product Owner", value: "product_owner" },
    SCRUM_MASTER: { name: "Scrum Master", value: "scrum_master" },
    AI_BUSINESS_ANALYST: { name: "AI Business Analyst", value: "ai_business_analyst" },

    AA_PDM: { name: "AA-PDM", value: "aa_product_manager" },
    SDR: { name: "SDR", value: "sdr" },
    CYBER_SECURITY: { name: "Cyber Security", value: "cyber_security" },
    TAC_ICP: { name: "TAC-ICP", value: "icp" },
    TAC_ICP_APO: { name: "TAC-ICP-APO", value: "apo" },
    TAC_PDM: { name: "TAC-PDM", value: "product_manager" },

    ICP: { name: "ICP", value: "icp" },
    SELF_PACED_PDM: { name: "SELF-PACED-PDM", value: "spp" },
    FAI: { name: "FAI", value: "fai" },
    
    ICP_APO:{ name: "ICP-APO", value: "apo" },
    PDM: { name: "PDM", value: "product_manager" },
    APM:{ name: "APM", value: "agile_project_manager" },
    ICP_ACC:{ name: "ICP-ACC", value: "icp_acc" },
    ATF:{ name: "ATF", value: "agile_team_facilitator" },
    SELF_APM:{ name: "SELF-APM", value: "self_apm" },

    SELF_PACED_SCRUM_MASTER: { name: "Self Paced Scrum Master", value: "self_paced_scrum_master" },
    SELF_PACED_PRODUCT_MANAGER: { name: "Self Paced Product Manager", value: "self_paced_product_manager" },
    SELF_PACED_AGILE_Project_Manager: { name: "Self Paced Agile Project Manager", value: "self_paced_agile_project_manager" },
    SELF_PACED_PRODUCT_MANAGER_LANDING: { 
        name: "Self Paced Product Manager (Landing)", 
        value: "self_paced_product_manager_landing" 
    },
    SELF_PACED_PRODUCT_OWNER_LANDING: { 
        name: "Self Paced Product Owner (Landing)", 
        value: "self_paced_product_owner_landing" 
    },
    SELF_PACED_BUSINESS_ANALYST_LANDING: { 
        name: "Self Paced Business Analyst (Landing)", 
        value: "self_paced_business_analyst_landing" 
    },
    SELF_PACED_SCRUM_MASTER_LANDING: { 
        name: "Self Paced Scrum Master (Landing)", 
        value: "self_paced_scrum_master_landing" 
    },
    ICP_CERTIFICATION: { 
        name: "Agile Fundamental (ICP) Certification", 
        value: "icp_certification" 
    },
    ICP_PDM_CERTIFICATION: { 
        name: "ICP - PDM Certification", 
        value: "icp_pdm_certification" 
    },
};
